(function () {
  function postTypeOf(x) {
    return (x && (x.post_type || (x.media && x.media.post_type))) || null;
  }
  function keep(x) {
    var pt = postTypeOf(x);
    return !pt || pt === "OWNER";
  }
  function filterData() {
    for (var k in window) {
      if (k.indexOf("omega_medias_") !== 0) continue;
      var d = window[k];
      if (d && Array.isArray(d.medias) && !d.__ownerFiltered) {
        d.medias = d.medias.filter(keep);
        d.__ownerFiltered = true;
      }
    }
  }
  function filterDom() {
    document.querySelectorAll("[data-item][data-media-products]").forEach(function (el) {
      if (el.dataset.ownerChecked) return;
      el.dataset.ownerChecked = "1";
      var item = null;
      try { item = window.omegaUtils.decodeBase64(el.getAttribute("data-item")); } catch (e) {}
      if (item && !keep(item)) el.remove();
    });
  }
  function run() { filterData(); filterDom(); }
  function start() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    var n = 0, iv = setInterval(function () { run(); if (++n > 40) clearInterval(iv); }, 200);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();